import { MenuItem, Select } from "@mui/material";
import React, { useState } from "react";
import {
  allowEverything,
  allowOnlyNumber,
  removeSpecialCharacters,
} from "../../../utils";
import "./style.scss";

interface Props {
  renderBusinessHours: any;
  handleInputChange: any;
  aggregatorConfig: any;
  paymentInfoList: any;
  setPaymentInfoList: any;
  paymentProvidersMap: any;
  DELIVERY_MODES: any;
  renderTextField: any;
  renderCustomDropDown: any;
  renderSwitchComponent: any;
}

const RistaPreferences = (props: Props) => {
  const {
    renderBusinessHours,
    handleInputChange,
    aggregatorConfig,
    paymentInfoList,
    setPaymentInfoList,
    paymentProvidersMap,
    DELIVERY_MODES,
    renderTextField,
    renderCustomDropDown,
    renderSwitchComponent,
  } = props;
  const [isRistaPreferencesOpen, setIsRistaPreferencesOpen] = useState(false);
  const VISIBILITY_TYPES: any = {
    public: {
      id: "public",
      text: "Public",
    },
    private: {
      id: "private",
      text: "Private",
    },
  };

  const TEXT_FIELD_CONFIG = {
    minOrderAmountPickup: {
      label: "Min Order Amount",
      placeholder: "Enter Min Order Amount",
      regexCheck: allowOnlyNumber,
      customClass: "",
      parentClass: "mb-[6px] w-[calc(50%-8px)]",
      value: aggregatorConfig?.preferences?.pickupPreferences?.minBillAmount,

      key: "preferences.pickupPreferences.minBillAmount",
      iconClass: "ic-currency",
    },
    minOrderAmountDelivery: {
      label: "Min Order Amount",
      placeholder: "Enter Min Order Amount",
      regexCheck: allowOnlyNumber,
      customClass: "",
      parentClass: "mb-[6px] mr-[8px] w-[calc(50%-8px)]",
      value: aggregatorConfig?.preferences?.deliveryPreferences?.minBillAmount,

      key: "preferences.deliveryPreferences.minBillAmount",
      iconClass: "ic-currency",
    },
    maxDistance: {
      label: "",
      placeholder: "",
      regexCheck: allowOnlyNumber,
      customClass: "!rounded-l-[0px] bg-white",
      parentClass: "mb-[6px] w-3/5",
      value: aggregatorConfig?.preferences?.deliveryPreferences?.maxDistance,

      key: "preferences.deliveryPreferences.maxDistance",
    },
    title: {
      label: "Title",
      placeholder: "Enter title",
      regexCheck: removeSpecialCharacters,
      customClass: "",
      parentClass: "mb-[6px]",
      value: aggregatorConfig?.preferences?.contactInfo?.title,
      key: "preferences.contactInfo.title",
      maxLength: 40,
    },
    phoneNumber: {
      label: "Phone Number",
      placeholder: "Enter phone number",
      regexCheck: allowOnlyNumber,
      customClass: "",
      parentClass: "mb-[6px]",
      value: aggregatorConfig?.preferences?.contactInfo?.phoneNumber,
      key: "preferences.contactInfo.phoneNumber",
      maxLength: 13,
    },
    email: {
      label: "Email",
      placeholder: "Enter Email",
      regexCheck: allowEverything,
      customClass: "",
      parentClass: "mb-[6px]",
      value: aggregatorConfig?.preferences?.contactInfo?.email,
      key: "preferences.contactInfo.email",
      maxLength: 40,
    },
    notes: {
      label: "Notes",
      placeholder: "Enter notes",
      regexCheck: allowEverything,
      customClass: "",
      parentClass: "mb-[6px]",
      value: aggregatorConfig?.preferences?.extras?.notes,
      key: "preferences.extras.notes",
      rows: 3,
      maxLength: 100,
    },
    priceForTwo: {
      label: "Price for two",
      placeholder: "",
      regexCheck: allowOnlyNumber,
      customClass: "",
      parentClass: "mb-[6px] mr-[8px] w-[calc(50%-8px)]",
      value: aggregatorConfig?.preferences?.extras?.priceForTwo,
      key: "preferences.extras.priceForTwo",
      iconClass: "ic-currency",
    },
    minOrderAmountExtras: {
      label: "Minimum Order Amount",
      placeholder: "",
      regexCheck: allowOnlyNumber,
      customClass: "",
      parentClass: "mb-[6px] ml-[8px] w-[calc(50%-8px)]",
      value: aggregatorConfig?.preferences?.extras?.minOrderAmount,
      key: "preferences.extras.minOrderAmount",
      iconClass: "ic-currency",
    },
  };

  const DROPDOWN_CONFIGS = {
    paymentInfo: {
      label: "Payment Info",
      optionsMap: paymentProvidersMap || {},
      placeholder: "Select Payments",
      uniqueKey: "mid",
      dropdownHeading: "Payments",
      searchPlaceholder: "Search a payment",
      parentClass: "w-full px-[24px] sm:px-[16px] mt-[24px]",
      key: "preferences.paymentInfo",

      isMultiSelect: true,
      preSelectedValues: paymentInfoList || [],
      onSubmit: (value: any) => setPaymentInfoList(value),
      getListItemText: (data: any) => data?.name,
    },
    deliveryModes: {
      label: "Delivery Modes",
      optionsMap: DELIVERY_MODES || {},
      placeholder: "Select Modes",
      uniqueKey: "id",
      dropdownHeading: "Delivery Modes",
      searchPlaceholder: "Search delivery modes",
      parentClass: "w-full px-[24px] sm:px-[16px]",
      key: "preferences.deliveryModes",

      isMultiSelect: true,
      preSelectedValues:
        aggregatorConfig?.preferences?.deliveryModes?.map((val: string) =>
          val?.toLowerCase()
        ) || [],
      onSubmit: (value: any) =>
        handleInputChange(value, "preferences.deliveryModes"),
      getListItemText: (data: any) => data?.name,
    },
    visibility: {
      label: "Visibility",
      optionsMap: VISIBILITY_TYPES,
      placeholder: "Select Option",
      uniqueKey: "id",
      parentClass: "w-full",
      key: "visibility",

      preSelectedValues:
        aggregatorConfig?.preferences?.extras?.visibility?.toLowerCase() || "",
      onSubmit: (value: any) =>
        handleInputChange(
          VISIBILITY_TYPES[value[0]]?.text,
          "preferences.extras.visibility"
        ),
      getListItemText: (data: any) => data?.text,
    },
  };

  function renderDeliveryArea() {
    return (
      <div className="delivery-area ml-[8px] w-[calc(50%-8px)]">
        <p className="text-14 text-[#656565] font-normal mb-[8px]">
          Delivery Area
        </p>
        <div className="flex w-full">
          <div className="h-[50px] w-2/5">
            <Select
              defaultValue=""
              labelId="mutiple-select-label"
              multiple={false}
              value={
                aggregatorConfig?.preferences?.deliveryPreferences
                  ?.distanceUnit || "km"
              }
              onChange={(e: any) =>
                handleInputChange(
                  e.target.value,
                  "preferences.deliveryPreferences.distanceUnit"
                )
              }
            >
              <MenuItem
                value="km"
                className="border-b-[1px] border-[#F0F0F0] opacity-100 flex justify-center cursor-pointer"
              >
                Km
              </MenuItem>
              <MenuItem
                value="mi"
                className="h-[46px] opacity-100 flex justify-center cursor-pointer"
              >
                Mile
              </MenuItem>
            </Select>
          </div>
          {renderTextField(TEXT_FIELD_CONFIG.maxDistance)}
        </div>
      </div>
    );
  }

  return (
    <>
      <div
        className="flex items-center bg-[#0074FB]/5 cursor-pointer py-[8px] px-[20px] sm:px-[12px]"
        onClick={() => setIsRistaPreferencesOpen((prevVal) => !prevVal)}
      >
        <div
          className={`rista-sprite ic-dropdown-blue ${
            isRistaPreferencesOpen ? "" : "right"
          }`}
        ></div>
        <p className="text-18 text-[#0074FB] font-semibold">Preferences</p>
        <p className="text-16 ml-[14px]"></p>
      </div>
      {isRistaPreferencesOpen ? (
        <>
          {renderCustomDropDown(DROPDOWN_CONFIGS.paymentInfo)}
          {renderCustomDropDown(DROPDOWN_CONFIGS.deliveryModes)}
          {aggregatorConfig?.preferences?.deliveryModes &&
          aggregatorConfig?.preferences?.deliveryModes?.indexOf("pickup") >
            -1 ? (
            <div className="border-t border-black/[0.14] p-[24px] sm:px-[16px]">
              <p className="text-17 font-semibold mb-[24px]">
                Pickup Preferences
              </p>
              {renderTextField(TEXT_FIELD_CONFIG.minOrderAmountPickup)}
            </div>
          ) : null}
          {aggregatorConfig?.preferences?.deliveryModes &&
          aggregatorConfig?.preferences?.deliveryModes?.indexOf("delivery") >
            -1 ? (
            <div className="border-t border-black/[0.14] p-[24px] sm:px-[16px]">
              <p className="text-17 font-semibold mb-[24px]">
                Delivery Preferences
              </p>
              <div className="flex items-center">
                {renderTextField(TEXT_FIELD_CONFIG.minOrderAmountDelivery)}
                {renderDeliveryArea()}
              </div>
            </div>
          ) : null}

          <div className="border-t border-black/[0.14] p-[24px] sm:px-[16px]">
            {renderBusinessHours()}
          </div>
          <div className="border-t border-black/[0.14] p-[24px] sm:px-[16px]">
            <p className="text-17 font-semibold mb-[24px]">Contact</p>
            {renderTextField(TEXT_FIELD_CONFIG.title)}
            {renderTextField(TEXT_FIELD_CONFIG.phoneNumber)}
            {renderTextField(TEXT_FIELD_CONFIG.email)}
          </div>
          <div className="border-t border-black/[0.14] p-[24px] sm:px-[16px]">
            <p className="text-17 font-semibold mb-[24px]">
              Additional Settings
            </p>
            {renderCustomDropDown(DROPDOWN_CONFIGS.visibility)}
            {renderTextField(TEXT_FIELD_CONFIG.notes)}
            <div className="flex items-center">
              {renderTextField(TEXT_FIELD_CONFIG.priceForTwo)}
              {renderTextField(TEXT_FIELD_CONFIG.minOrderAmountExtras)}
            </div>
            {renderSwitchComponent({
              label: "Auto Accept Paid Orders",
              key: "preferences.extras.autoAccept",
              onVal: 1,
              offVal: 0,
            })}
            {renderSwitchComponent({
              label: "Allow Pre Orders",
              key: "preferences.extras.allowPreOrder",
              onVal: 1,
              offVal: 0,
            })}
          </div>
        </>
      ) : null}
    </>
  );
};

export default RistaPreferences;
